import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LevelsService } from '@services/levels.service';
import { UploadService } from '@services/upload.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-newlevel',
  templateUrl: './newlevel.component.html',
  styleUrls: ['./newlevel.component.css']
})
export class NewlevelComponent implements OnInit {
  definitionForm:FormGroup;
  submitted=false;
  @Input() data:any;
  @Input() courseid:any;
  color="#FFFFFF";
  constructor(
    private formBuilder:FormBuilder,
    private activeModal:NgbActiveModal,
    private toastrService: ToastrService,
    private languageService:LevelsService,
    private uploadService:UploadService) { }

  ngOnInit() {

    this.definitionForm=this.formBuilder.group({
      'name':['',Validators.required],
      'description':['',Validators.required],
      'iconUrl':['',Validators.required],
      'courseId':[this.courseid],
      'header':['',Validators.required],
      'order':['',Validators.required],
      'color':[''],
      'isPremium':[false]
  
    });

    if(this.data){
      this.definitionForm.get("name").patchValue(this.data.name);
      this.definitionForm.get("description").patchValue(this.data.description);
      this.definitionForm.get("iconUrl").patchValue(this.data.iconUrl);
      this.definitionForm.get("courseId").patchValue(this.data.courseId);
      this.definitionForm.get("header").patchValue(this.data.header);
      this.definitionForm.get("order").patchValue(this.data.order);
      this.definitionForm.get("color").patchValue(this.data.color);
      this.definitionForm.get("isPremium").patchValue(this.data.isPremium);

      this.color=this.data.color;
    }

    
  }



  save(){

   

    if(!this.definitionForm.valid){
      this.definitionForm.markAllAsTouched();
      this.toastrService.clear();
      this.toastrService.warning("Lütfen gerekli alanları doldurunuz","Uyarı");
      return;
    }
    this.submitted=true;

    this.definitionForm.get("color").patchValue(this.color);

    if(this.data){

      this.languageService.update(this.data.id,this.definitionForm.value).subscribe(res=>{

        this.toastrService.clear();
        this.toastrService.success("Seviye güncelleme başarılı","İşlem Başarılı");
        this.definitionForm.reset();
        this.submitted=false;
        this.files.splice(0, 1);
        this.definitionForm.get("iconUrl").patchValue("");
        this.color="#FFFFFF";
      },err=>{
        this.submitted=false;
        this.toastrService.clear();
        this.toastrService.error("Kayıt sırasında hata oluştu","Hata");
      });


    }else{
      this.languageService.add(this.definitionForm.value).subscribe(res=>{

        this.toastrService.clear();
        this.toastrService.success("Seviye ekleme başarılı","İşlem Başarılı");
        this.definitionForm.reset();
        this.submitted=false;
        this.files.splice(0, 1);
        this.definitionForm.get("iconUrl").patchValue("");
        this.color="#FFFFFF";
      },err=>{
        this.submitted=false;
        this.toastrService.clear();
        this.toastrService.error("Kayıt sırasında hata oluştu","Hata");
      });
    }
  }





  
  close(){
    this.activeModal.close();
  }


  
  files: File[] = [];

  SelectSingleFile(event) {
    this.files.push(...event.addedFiles);
   
    if(this.files[0].size>2024000){
      this.toastrService.clear();
      this.toastrService.warning("2 MB'dan büyük dosya yükleyemezsiniz.","Uyarı");
      this.files.splice(this.files.indexOf(event), 1);
      return;
    }
    
  
     let formData=new FormData();
     formData.append('file',this.files[0],this.files[0].name);
      this.uploadService.file(formData,"levels").subscribe(res=>{
        this.definitionForm.get("iconUrl").patchValue(res[0]);
      
      },err=>{
        this.toastrService.clear();
        this.toastrService.error("Görsel yüklenirken bir hata oluştu.","Hata");
        this.files.splice(this.files.indexOf(event), 1);
    
      });
    
  
  }
  
  SinglefileonRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
    this.definitionForm.get("iconUrl").patchValue("");
  }

}
